export const CHECKBOX_MARKDOWN_UNCHECKED = '[ ]';
export const CHECKBOX_MARKDOWN_CHECKED = '[x]';
